import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_FEATURES';

const en = {
    notNowBtn: 'Not Now',
    okBtn: 'Ok',
    creditCardRecon_title: 'Our new Split Credit Card Reconciliation Worksheet',
    creditCardRecon_content:
        'Would you like us to show you how to perform credit card reconciliations using the split worksheet?',
    creditCardRecon_cbutton: 'Show Me',
    filters_title: 'Search directly from the headings',
    filters_content: 'Hover on the header and click the filter icon to search your data',
    bankRecon_Title: 'Have you seen our split reconciliation work area?',
    bankRecon_content: 'Have you seen our split reconciliation work area?',
    bankRecon_cbutton: 'Take a Look',
    NotNow: 'Not Now',
    accRecon_Title: 'Have you seen our split reconciliation work area?',
    accRecon_content: 'A new experience awaits you in the Split Reconciliation Work Area.',
    gotIt: 'OK, got it',
    automations_newMenu_title: 'Rules are now in the Automations menu',
    automations_feature_title: 'Check out the new Automations menu',
    automations_content: ` Here you can find: 
    Macros
    Define Business Rules
    Define Autofill Rules
    `,
    automation_oldMenu_title: ' Macros is now in the Automations menu',
    automation_oldMenu_content: 'Check out the redesigned Macros and its new functionalities ',
    israelTaxRegulationUpdateTitle: 'Update Minimum Amount for Invoice Allocation Numbers - Israel',
    israelTaxRegulationUpdatePrimaryButton: 'Run',
    israelTaxRegulationUpdateSecondaryButton: "Don't show again",
    israelTaxRegulationUpdateList1:
        'Run the program to update your system for 2026 Israeli tax regulations.',
    israelTaxRegulationUpdateList2_firstCycle:
        'This will set the minimum amount for invoice allocation numbers to 10,000 NIS. The AmountRequiringApp financial constant will update automatically.',
    israelTaxRegulationUpdateList2_secondCycle:
        'This will set the minimum amount for invoice allocation numbers to 5,000 NIS. The AmountRequiringApp financial constant will update automatically.',
    israelTaxRegulationUpdateList3:
        'You can also run the Tax Regulation Update program from the menu later.'
};

const he = {
    notNowBtn: 'הבנתי',
    okBtn: 'הבנתי',
    creditCardRecon_title: 'כבר ראית את המשטח המפוצל להתאמות כרטיסי אשראי?',
    creditCardRecon_content: 'חוויה חדשנית להתאמות כרטיסי אשראי עם דפי אשראי מחכה לך במשטח המפוצל.',
    creditCardRecon_cbutton: 'אני רוצה לראות',
    filters_title: 'לחפש ישר מהכותרת ',
    filters_content: 'רחפו מעל שמות השדות, לחצו על אייקון הפילטר, ובחרו איזה מידע להציג במסך.',
    bankRecon_Title: 'כבר ראית את משטח ההתאמות המפוצל?',
    bankRecon_content: 'חווית התאמות חדשנית מחכה לך במשטח המפוצל להתאמות בנק.',
    bankRecon_cbutton: 'אני רוצה לראות',
    NotNow: 'לא עכשיו',
    accReconn_Title: 'כבר ראית את משטח ההתאמות המפוצל?',
    accRecon_content: 'חווית התאמות חדשנית מחכה לך במשטח המפוצל לניתוח כרטיסים.',
    gotIt: 'הבנתי',
    automations_newMenu_title: 'החוקים עברו לכפתור "אוטומציות" במסכים',
    automations_feature_title: 'פעולות אוטומטיות בלחיצת כפתור',
    automations_content: `כאן תמצאו את:
    - המאקרו החדש
    - החוקים העסקיים
    - החוקים לערכים בשדות`,
    automation_oldMenu_title: 'המאקרו עבר לכפתור "אוטומציות" במסכים',
    automation_oldMenu_content:
        'המאקרו המוכר התחדש ביכולות ונראות חדשים, ומופעל מעכשיו מכפתור "אוטומציות" בכותרת המסכים. ',
    israelTaxRegulationUpdateTitle: 'עדכון סף מינימום למספרי הקצאה - חשבוניות ישראל',
    israelTaxRegulationUpdatePrimaryButton: 'הפעלה',
    israelTaxRegulationUpdateSecondaryButton: 'לא להציע לי שוב',
    israelTaxRegulationUpdateList1:
        'לחצו על הכפתור כדי להפעיל תוכנית שתעדכן את נתוני המערכת בהתאם לרגולציית המיסים לשנת 2026.',
    israelTaxRegulationUpdateList2_firstCycle:
        'התוכנית תעדכן את הסכום המינימלי לבקשת מספר הקצאה לחשבונית ל- 10,000 ש"ח. קבוע הכספים AmountRequiringApp יתעדכן אוטומטית.',
    israelTaxRegulationUpdateList2_secondCycle:
        'התוכנית תעדכן את הסכום המינימלי לבקשת מספר הקצאה לחשבונית ל- 5,000 ש"ח. קבוע הכספים AmountRequiringApp יתעדכן אוטומטית.',
    israelTaxRegulationUpdateList3:
        'תמיד אפשר להפעיל את התוכנית עדכון רגולציית מסים ישירות מהתפריט.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'creditCardRecon_title',
    2: 'creditCardRecon_content',
    3: 'notNowBtn',
    4: 'creditCardRecon_cbutton',
    5: 'filters_title',
    6: 'filters_content',
    7: 'okBtn',
    8: 'bankRecon_Title',
    9: 'bankRecon_content',
    10: 'bankRecon_cbutton',
    11: 'NotNow',
    12: 'accReconn_Title',
    13: 'accRecon_content',
    14: 'gotIt',
    17: 'automations_newMenu_title',
    18: 'automations_content',
    19: 'automations_feature_title',
    20: 'automation_oldMenu_title',
    21: 'automation_oldMenu_content'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
